import { StaffSessionViewModel } from "@lumora/core";
import { client } from "../client.js";
import { sessionStaffIdentity } from "./staffIdentity.js";

/** Signed-in staff user, shared by the app shell, login, and staff pages. */
export const staffSession = new StaffSessionViewModel(client, sessionStaffIdentity);
